// API pour la gestion des Purchase Orders admin avec persistance PostgreSQL
const API_BASE_URL = process.env.REACT_APP_LOCAL_API ? `${process.env.REACT_APP_LOCAL_API}/admin-orders` : '/api/admin-orders';

// Sauvegarder une Purchase Order en draft
export const saveDraftPurchaseOrder = async (draftData) => {
  try {const response = await fetch(`${API_BASE_URL}/save-draft`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(draftData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.details || errorData.error || 'Erreur lors de la sauvegarde');
    }

    const result = await response.json();return result;
  } catch (error) {
    console.error('❌ Error saving draft purchase order:', error);
    throw error;
  }
};

// Récupérer le draft d'un vendor spécifique
export const getDraftByVendor = async (vendorId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/draft/vendor/${vendorId}`);

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.details || errorData.error || 'Erreur chargement draft vendor');
    }

    const result = await response.json();return result.draft_order;
  } catch (error) {
    console.error('❌ Error loading draft vendor:', error);
    throw error;
  }
};

// Calculer le total d'une commande
export const calculateOrderTotal = (lineItems) => {
  if (!Array.isArray(lineItems) || lineItems.length === 0) {
    return 0;
  }

  return lineItems.reduce((total, item) => {
    const quantity = parseInt(item.quantity) || 0;
    const rate = parseFloat(item.rate) || parseFloat(item.purchase_rate) || 0;
    return total + (quantity * rate);
  }, 0);
};

// Préparer les données pour la sauvegarde temps réel
export const prepareDraftData = (vendorId, vendorName, selectedProducts, quantities, notes = '') => {
  const lineItems = selectedProducts.map(product => ({
    item_id: product.item_id,
    name: product.name,
    sku: product.sku,
    description: product.description || '',
    quantity: quantities[product.item_id] || 0,
    rate: product.purchase_rate || product.rate || 0,
    unit: product.unit || 'pcs'
  }));

  const totalAmount = calculateOrderTotal(lineItems);

  return {
    vendor_id: vendorId,
    vendor_name: vendorName,
    line_items: lineItems,
    total_amount: totalAmount,
    notes: notes
  };
};

// Lister toutes les Purchase Orders en draft
export const getDraftPurchaseOrders = async (vendorId = null) => {
  try {
    const params = vendorId ? `?vendor_id=${vendorId}` : '';
    const response = await fetch(`${API_BASE_URL}/drafts${params}`);

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.details || errorData.error || 'Erreur lors de la récupération');
    }

    const result = await response.json();return result.draft_orders;
  } catch (error) {
    console.error('❌ Error loading draft purchase orders:', error);
    throw error;
  }
};

// Récupérer une Purchase Order draft spécifique
export const getDraftPurchaseOrder = async (draftId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/draft/${draftId}`);

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.details || errorData.error || 'Commande draft non trouvée');
    }

    const result = await response.json();return result.draft_order;
  } catch (error) {
    console.error('❌ Error loading draft purchase order:', error);
    throw error;
  }
};

// Envoyer une Purchase Order draft à Zoho
export const sendDraftToZoho = async (draftId, sentBy = 'admin') => {
  try {const response = await fetch(`${API_BASE_URL}/send-to-zoho/${draftId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sent_by: sentBy }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.details || errorData.error || 'Erreur lors de l\'envoi à Zoho');
    }

    const result = await response.json();return result;
  } catch (error) {
    console.error('❌ Error sending to Zoho:', error);
    throw error;
  }
};

// Mettre à jour une Purchase Order draft
export const updateDraftPurchaseOrder = async (draftId, updateData) => {
  try {const response = await fetch(`${API_BASE_URL}/draft/${draftId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.details || errorData.error || 'Erreur lors de la mise à jour');
    }

    const result = await response.json();return result;
  } catch (error) {
    console.error('❌ Error updating draft purchase order:', error);
    throw error;
  }
};

// Supprimer une Purchase Order draft
export const deleteDraftPurchaseOrder = async (draftId, reason = 'cancelled') => {
  try {const response = await fetch(`${API_BASE_URL}/draft/${draftId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ reason }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.details || errorData.error || 'Erreur lors de la suppression');
    }

    const result = await response.json();return result;
  } catch (error) {
    console.error('❌ Error deleting draft purchase order:', error);
    throw error;
  }
};
